import React from 'react';
import { getStatusLabel } from '../../lib/support/ticketsService';

const TicketList = ({ tickets = [], onSelect }) => {
  if (!tickets.length) {
    return (
      <div className="support-empty">No tickets yet. Create your first ticket in seconds.</div>
    );
  }

  return (
    <div className="support-ticket-list">
      {tickets.map((ticket) => {
        const status = ticket.status || 'open';
        return (
          <div
            key={ticket.id}
            className="support-ticket-item"
            role="button"
            tabIndex={0}
            onClick={() => onSelect(ticket)}
            onKeyDown={(event) => event.key === 'Enter' && onSelect(ticket)}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div className="support-ticket-title">{ticket.subject}</div>
              <span className={`support-pill ${status}`}>{getStatusLabel(status)}</span>
            </div>
            <div className="support-ticket-meta">
              <span>{ticket.ticketNumber}</span>
              <span>{ticket.updatedAt?.toDate ? ticket.updatedAt.toDate().toLocaleDateString() : 'Just now'}</span>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default TicketList;
